class TicketDraft {
    constructor ( contractId ) {
        if (!contractId) {
            contractId = 'noContractId'
        }
        this.lsswitch = true
        this.lsKey= `notp-ticket-draft-${contractId}`
        if (typeof process !== 'undefined' &&
            (
                process.server ||
                process.SERVER_BUILD ||
                (process.env && process.env.VUE_ENV === 'server')
            )
        ) {
            this.lsswitch = false
            return
        }
        try {
            const test = '__localstorage-test__'
            window.localStorage.setItem(test, test)
            window.localStorage.removeItem(test)
        } catch (e) {
            this.lsswitch = false
            console.error('Local storage is not supported')
        }
        this.ls = window.localStorage
    }

    draft (data) {
        if (!this.lsswitch) return;
        this.ls.setItem(this.lsKey, JSON.stringify(data))
    }

    hasDraft () {
        return this.lsswitch?!!this.ls[this.lsKey]:false
    }

    clearDraft () {
        if (this.lsswitch) {
            this.ls.removeItem(this.lsKey)
        }
    }

    useDraft () {
        return this.lsswitch?JSON.parse(this.ls[this.lsKey]):false
    }
}

export default TicketDraft



// WEBPACK FOOTER //
// ./src/helpers/ticketDraft.js